import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store';

import EntranceService from '@/io/entrance.js';

import NotFound from '@/views/NotFound.vue';

import Entrance from '@/views/Entrance.vue';
import ChooseCompany from '@/views/ChooseCompany.vue';
import WechatBlank from '@/views/WechatBlank.vue';

import Dashboard from '@/views/Dashboard.vue';
import StaffManage from '@/views/StaffManage.vue';
import CustomerManage from '@/views/CustomerManage.vue';
import CustomerInfo from '@/views/CustomerInfo.vue';
import ConfirmStaff from '@/views/ConfirmStaff.vue';
import ExtraStaff from '@/views/ExtraStaff.vue';
import ExtraStaffInfo from '@/views/ExtraStaffInfo.vue';
import CertificationManage from '@/views/CertificationManage.vue';
import ContractManage from '@/views/ContractManage.vue';
import RiskControlStatistics from '@/views/RiskControlStatistics.vue';
import PassengerFlowStatistics from '@/views/PassengerFlowStatistics.vue';
import IdentificationLog from '@/views/IdentificationLog.vue';
import SearchByPicture from '@/views/SearchByPicture.vue';


Vue.use(VueRouter);

let beforeEnter = (to, from, next) => {
  EntranceService.isLogin().then(res => {
    let isLogin = res.status;
    Store.commit('setIsLogin', isLogin);
    if (isLogin) {
      next();
    } else {
      next(`/entrance?redirect=${to.fullPath}`);
    }
  }).catch(() => { });
}

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/entrance',
    name: 'Entrance',
    component: Entrance
  },
  {
    path: '/choose_company',
    name: 'ChooseCompany',
    component: ChooseCompany
  },
  {
    path: '/wechat_blank',
    name: 'WechatBlank',
    component: WechatBlank
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      breadcrumbs: ['控制台'],
    },
    beforeEnter
  },
  {
    path: '/staff_manage',
    name: 'StaffManage',
    component: StaffManage,
    meta: {
      breadcrumbs: ['人员管理', '集团员工'],
    },
    beforeEnter
  },
  {
    path: '/customer_manage',
    name: 'CustomerManage',
    component: CustomerManage,
    meta: {
      breadcrumbs: ['人员管理', '项目客户'],
    },
    beforeEnter
  },
  {
    path: '/customer_manage/edit/:id',
    name: 'EditCustomer',
    component: CustomerInfo,
    meta: {
      breadcrumbs: ['人员管理', '项目客户', '编辑客户'],
    },
    beforeEnter
  },
  {
    path: '/confirm_staff',
    name: 'ConfirmStaff',
    component: ConfirmStaff,
    meta: {
      breadcrumbs: ['人员管理', '待确认人员'],
    },
    beforeEnter
  },
  {
    path: '/extra_staff',
    name: 'ExtraStaff',
    component: ExtraStaff,
    meta: {
      breadcrumbs: ['人员管理', '外部员工'],
    },
    beforeEnter
  },
  {
    path: '/extra_staff/edit/:id',
    name: 'EditExtraStaff',
    component: ExtraStaffInfo,
    meta: {
      breadcrumbs: ['人员管理', '外部员工', '编辑员工'],
    },
    beforeEnter
  },
  {
    path: '/certification_manage',
    name: 'CertificationManage',
    component: CertificationManage,
    meta: {
      breadcrumbs: ['认证管理'],
    },
    beforeEnter
  },
  {
    path: '/contract_manage',
    name: 'ContractManage',
    component: ContractManage,
    meta: {
      breadcrumbs: ['签约管理'],
    },
    beforeEnter
  },
  {
    path: '/risk_control_statistics',
    name: 'RiskControlStatistics',
    component: RiskControlStatistics,
    meta: {
      breadcrumbs: ['统计分析', '风控统计'],
    },
    beforeEnter
  },
  {
    path: '/passenger_flow_statistics',
    name: 'PassengerFlowStatistics',
    component: PassengerFlowStatistics,
    meta: {
      breadcrumbs: ['统计分析', '客流统计'],
    },
    beforeEnter
  },
  {
    path: '/identification_log',
    name: 'IdentificationLog',
    component: IdentificationLog,
    meta: {
      breadcrumbs: ['识别日志'],
    },
    beforeEnter
  },
  {
    path: '/search_by_picture',
    name: 'SearchByPicture',
    component: SearchByPicture,
    meta: {
      breadcrumbs: ['以图搜人'],
    },
    beforeEnter
  },
  {
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  routes
});

export default router;
